
import { useNavigate } from 'react-router-dom';

export default function CartEmpty() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-20 sm:py-32 px-4">
      <div className="relative mb-8">
        <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-[#F5F0EB] flex items-center justify-center">
          <i className="ri-shopping-bag-2-line text-5xl sm:text-6xl text-[#D4A574]/40"></i>
        </div>
        <div className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-[#143D28]/10 flex items-center justify-center">
          <i className="ri-emotion-sad-line text-lg text-[#143D28]/40"></i>
        </div>
      </div>
      <h2 className="text-2xl sm:text-3xl font-serif text-gray-900 mb-3 text-center">
        Votre panier est vide
      </h2>
      <p className="text-sm text-gray-500 mb-8 text-center max-w-sm leading-relaxed">
        Découvrez notre collection exquise de parfums et d&apos;huiles capillaires pour sublimer votre beauté
      </p>
      <button
        onClick={() => navigate('/products')}
        className="group px-8 py-3.5 bg-[#143D28] text-white text-sm font-medium rounded-full hover:bg-[#0F2E1E] transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
      >
        <span>DÉCOUVRIR LA COLLECTION</span>
        <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform duration-300"></i>
      </button>
    </div>
  );
}
